export const ResultStatus = Object.freeze({
	Open: 'open',
	Closed: 'closed',
});
